import { useCreations } from './useCreations';
import CreationsCharts from '../../../components/CreationsCharts/CreationsCharts';
import cn from 'classnames';
import styles from './Creations.module.css';
import moment from 'moment';
import { useState } from 'react';
import { DateRangeFilter } from '@round/whitelabel-ui';

type Props = {
    audioId: number;
    className?: string;
};

const Creations = ({ audioId, className }: Props) => {
    const today = moment();
    const twoWeeksAgo = moment().subtract(2, 'weeks');

    const [date, setDate] = useState<[Date] | [Date, Date] | null | undefined>([twoWeeksAgo.toDate(), today.toDate()]);
    const [startDate, endDate] = date ?? [];

    const { data, isFetching, isError } = useCreations({
        audioId,
        start_date: (startDate ? moment(startDate) : twoWeeksAgo).format('YYYY-MM-DD'),
        end_date: (endDate ? moment(endDate) : today).format('YYYY-MM-DD'),
    });

    const dataSets = {
        daily: {
            data: data?.daily || [],
            borderColor: '#e1306c',
        },
        totals: {
            data: data?.totals || [],
            borderColor: '#e1306c',
        },
    };

    return (
        <div className={cn(styles.container, className)}>
            <div className={styles.filters}>
                <DateRangeFilter value={date} onChange={setDate} maxDate={today.toDate()} />
            </div>

            <CreationsCharts data={dataSets} isLoading={isFetching} hasError={isError} />
        </div>
    );
};

export default Creations;
